import { $axios } from "lib/axios";

export const postVerification = async ({
  phoneNumber,
  email,
  to,
  memberType,
}: {
  phoneNumber?: string;
  email?: string;
  to: "sms" | "email";
  memberType: "normal" | "corporation";
}) => {
  const res = await $axios.post(`/member/${memberType}/signup/${to}`, {
    ...(to === "sms" ? { phoneNumber } : { email }),
  });
  return res.data;
};

export const patchVerification = async ({
  type,
  code,
  verificationId,
}: {
  type: "sms" | "email";
  code: string;
  memberType: "normal" | "corporation";
  verificationId: string;
}) => {
  const res = await $axios.patch(`/verification/${type}`, {
    code,
    verificationId,
  });

  return res.data;
};
